module.exports = __webpack_public_path__ + "img/foto12.0f2c7cc5.jpg";